import useEnvironmentType from '../../../hooks/useDevEnvironment'
import { EnvTypes } from '../../../types/andTypes'
import { StageBanner, BannerText, BannerLink } from './banner-styles'

const Banner = () => {
  const Environment = useEnvironmentType()
  if (Environment === EnvTypes.DEV) {
    return (
      <StageBanner data-testid={'env-banner'}>
        <BannerText>
          This is the Development Environment. Kindly use the{' '}
          <BannerLink href={'https://and-space-prod.web.app/'}>AND Space</BannerLink> live
          environment to book your desk.
        </BannerText>
      </StageBanner>
    )
  } else if (Environment === EnvTypes.STAGING) {
    return (
      <StageBanner data-testid={'env-banner'}>
        <BannerText>
          This is the Staging Environment. Kindly use the{' '}
          <BannerLink href={'https://and-space-prod.web.app/'}>AND Space</BannerLink> live
          environment to book your desk.
        </BannerText>
      </StageBanner>
    )
  } else {
    return null
  }
}

export default Banner
